/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class HttpTimeoutInterceptor implements HttpInterceptor {
  constructor(private messageService: MessageService) {}

  translateService = inject(TranslateService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip JSONP requests (e.g., Google Maps API) - they don't support headers/interceptors
    if (req.url.includes('callback=') || req.url.includes('maps.googleapis.com')) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (req.method === 'GET') {
          return throwError(() => err);
        }
        else {
          if (err.status === 504) {
            this.messageService.add({
              key: 'global-error',
              severity: 'warn',
              summary: this.translateService.instant('httpErrors.timeoutError'),
              life: 20000,
              detail: this.translateService.instant('httpErrors.timeoutErrorDetail'),
            });

            const response = new HttpResponse({
              body: { message: 'Error handled', originalError: err.message },
              status: 200,
              statusText: 'OK',
            });

            return of(response);
          } else {
            return throwError(() => err);
          }
        }
      })
    );
  }
}
